//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    data() {
        return {
            isMobileSidebarVisible: false,

            navItems: [
                {text: this.$t('label.press_about'), to: this.$web('about.index')},
                {text: this.$t('label.press_news'), to: this.$web('news.index')},
                {text: this.$t('label.downloads'), to: this.$web('downloads.index')},
            ]
        }
    },

    computed: {
        sidebarItems() {
            return [
                {
                    items: [
                        {title: this.$t('label.press_about'), to: this.$web('about.index')},
                        {title: this.$t('label.press_news'), to: this.$web('news.index')},
                        {title: this.$t('label.downloads'), to: this.$web('downloads.index'), divided: true},
                        {title: this.$t('action.to_spoferan'), to: this.$config.spoferanUrl},
                    ]
                }
            ]
        },

        footerItems() {
            return [
                {
                    title: this.$t('label.product'),
                    items: [
                        {to: this.$config.aboutUrl, text: this.$t('label.general'), exact: true},
                        {to: `${this.$config.aboutUrl}/spoferan`, text: 'SPOFERAN'},
                        {to: `${this.$config.aboutUrl}/resultastic`, text: 'resultastic'},
                        {to: `${this.$config.aboutUrl}/clubmanager`, text: this.$t('label.clubs')},
                    ]
                },
                {
                    title: this.$t('label.company'),
                    items: [
                        {to: this.$web('about.index'), text: this.$t('label.general')},
                        {to: this.$config.jobsUrl, text: this.$t('label.jobs')},
                        {to: this.$web('index'), text: this.$t('label.press')},
                        {to: this.$spoferan('team'), text: this.$t('label.team')},
                    ]
                },
                {
                    title: this.$t('label.help_and_contact'),
                    items: [
                        {to: this.$spoferan('contact'), text: this.$t('label.contact')},
                        {to: this.$spoferan('support'), text: this.$t('label.support')},
                        {to: this.$config.guideUrl, text: this.$t('label.guide')},
                        {to: `${this.$config.guideUrl}/spoferan/faq`, text: this.$t('label.faq')}
                    ]
                },
                {
                    title: this.$t('label.policies'),
                    items: [
                        {to: this.$spoferan('gtc'), text: this.$t('label.gtc')},
                        {to: this.$spoferan('privacy'), text: this.$t('label.privacy')},
                        {to: this.$spoferan('imprint'), text: this.$t('label.imprint')},
                        {to: this.$config.spoferanUrl, text: this.$t('action.to_spoferan')},
                    ]
                },
            ]
        }
    }
}
